import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../pages-list/model/pages-list.constants";
import { editPagesAPI, editPromoCode } from "./pages-edit.component.service";
import PromoCodeEditTemplateComponent from "./pages-edit.template.component";
import { getPagesInputs, getPromoCodeInputs } from "../model/pages.modal";
import PagesEditTemplateComponent from "./pages-edit.template.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  PAGES_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const PagesEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let pagesPayload = {};
    for (let i = 0; i < values.length; i++) {
      pagesPayload[values[i].name] = values[i].value;
    }
    console.log({ pagesPayload });
    console.log(location.state.row.id);
    // INFO : call create api
    const pagesResponse = await editPagesAPI(
      location?.state?.row?.id,
      pagesPayload
    );
    console.log({ location });
    console.log({ pagesPayload });
    console.log({ pagesResponse });

    // INFO : check api response and show relevant alert message
    if (pagesResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: pagesResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getPagesInputs({
      title: location?.state?.row?.title || "",
      meta_data: location?.state?.row?.meta_data || "",
      slug: location?.state?.row?.slug || "",
      content: location?.state?.row?.content || "",
    }),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <PagesEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default PagesEditComponent;
